







































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {GetTenantInfo} from '../../../api/realTime'
import myTable from '../../../components/table/my-table.vue'
import ECharts from 'vue-echarts'
import walden from '../../../components/charts/themes/walden.json'
import {GetDialysisCaseTime} from '../../../api/realTime'

@Component({
    components: {ECharts,myTable}
})
export default class extends AbpBase {
    created(){
        ECharts.registerTheme('ovilia-green', walden);
        this.getSelects()
        this.getData()
    }
    option = {}
    queryform = {
        tenantId:[]
    }
    tenantOptions = []
    //获取下拉框
    async getSelects(){
        this.tenantOptions = (await GetTenantInfo({})).data
    }
    searchPopShow = false
    tabs:any = [
        {closable:false,key:0,name:`本月（${this.getYear}/${this.getMonth}）`,year:this.getYear,month:this.getMonth,searchType:0},
        {closable:false,key:0,name:`本年（${this.getYear}）`,year:this.getYear,month:this.getMonth,searchType:1},
        {closable:false,key:0,name:'年份统计',year:this.getYear,month:this.getMonth,searchType:2},
    ]
    activeName = `本月（${this.getYear}/${this.getMonth}）`
    removeTab(targetName){
        let ri;
        this.tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
                if (nextTab) {
                    this.activeName = nextTab.name;
                }
                ri = index
            }
        });
        this.tabs.splice(ri,1)
        this.getData()
    }
    detail(row:any){
        let tab = this.tabs.find((item:any)=>{return item.name == row.date.replace(/-/,'/')})
        if(tab){
            this.activeName = row.date.replace(/-/,'/')
            this.getData()
            return false 
        }
        this.tabs.push({
            closable:true,
            key:0,
            name:row.date.replace(/-/,'/'),
            year:row.date.length == 4 ? row.date : row.date.split('-')[0],
            month:row.date.length == 4 ? 0 : row.date.split('-')[1],
            searchType:row.date.length == 4 ? 1 :0
        })
        this.activeName = row.date.replace(/-/,'/')
        this.searchType = row.date.length == 4 ? 1 : 0
        this.getData()
    }
    tabChange(){
        let tab = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.searchType = tab.searchType
        this.getData()
    }
    list = []
    columns = []
    renderColumns(){
        this.columns = [
            {
                title:this.activeName,
                key: 'date',
                width:150,
                render:(h:any,p:any)=> {
                    let d = this.searchType == 0 ?'':h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                marginLeft:'20px',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p.row)
                                }
                            }
                        },'详情')
                    return h('div',[
                        h('span',p.row.date),
                        d
                    ])
                },
            },
            {
                title: 'HD',
                key: 'hd',
            },
            {
                title: 'HDF',
                key: 'hdf',
            },
            {
                title: 'HP',
                key: 'hp',
            },
            {
                title: 'HF',
                key: 'hf',
            },
            {
                title: 'HDP',
                key: 'hdp',
            },
            {
                title: '单超',
                key: 'dc',
            },
            {
                title: 'CRRT',
                key: 'crrt',
            },
            {
                title: 'ARRT',
                key: 'arrt',
            },
            {
                title: 'SCUF',
                key: 'scuf',
            },
            {
                title: 'CVVH',
                key: 'cvvh',
            },
            {
                title: 'CVVHD',
                key: 'cvvhd',
            },
            {
                title: 'CVVHDF',
                key: 'cvvhdf',
            },
            {
                title: 'PE',
                key: 'pe',
            },
            {
                title: '总共',
                key: 'number',
            },
        ]
    }
    searchType = 0
    async getData(){
        this.list = []
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.searchType = active.searchType
        this.renderColumns()
        let data = {
            SearchType:this.searchType,
            TenantIds:this.queryform.tenantId,
            Year:active.year,
            Month:active.month
        }
        let res = await GetDialysisCaseTime(data)
        this.list = res.data
        this.renderCharts(res.data)
    }
    renderCharts(data:any){
        let xAxis = ["HD", "HDF", "HP", "HF", "HDP", "单超", "CRRT", "ARRT", "SCUF", "CVVH", "CVVHD", "CVVHDF", "PE"]
        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            legend:{
                data:this.searchType==2?data.map((v:any)=>{return v.date}):xAxis,
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data:this.searchType==2?xAxis:data.map((v:any)=>{return v.date}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                },
            ],
            series: this.searchType==2?data.map((v:any)=>{
                return {
                    name:v.date,
                    type: 'bar',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data:this.getValue(xAxis,v),
                }
            }):xAxis.map((v:any)=>{
                return {
                    name:v,
                    type: 'line',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data:this.getValue2(data,v),
                }
            })
        }
    }
    getValue(xAxis:any,row:any){
        let list = [];
        xAxis.forEach(v => {
            v = v.toLowerCase();
            for (const key in row) {
                if(v == key || (v =='单超' && key == 'dc')) list.push(row[key])
            }
        });
        return list
    }
    getValue2(data:any,v:any){
        let list = [];
        v = v.toLowerCase();
        data.forEach(item => {
            for (const key in item) {
                if(v == key || (v =='单超' && key == 'dc')) list.push(item[key])
            }
        });
        return list
    }
    get getYear(){
        let now = new Date();
        return now.getFullYear();
    }
    get getMonth(){
        let now = new Date();
        return now.getMonth()+1;
    }
    downxlsx(){
        let XLSX = this.$XLSX;
        var xlsxParam = { raw: true };//转换成excel时，使用原始的格式
        let a = document.createElement('div')
        a.innerHTML = document.querySelector("#mytable").outerHTML
        a.innerHTML = a.innerHTML.replace(/详情/g, '');
        var wb = XLSX.utils.table_to_book(a,xlsxParam);//mytable为表格的id名
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
        });
        let filename = `患者透析例次${this.activeName}`+".xlsx"
        try {
            this.$FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            filename
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    }
}
